import { useLang } from "@/context/LanguageContext";
import { useEditMode } from "@/context/EditModeContext";
import { RichTextEditor } from "@/components/site/RichTextEditor";
import { Trash2 } from "lucide-react";

// A custom, admin-added text section (rich text, per language).
export function TextBlockSection({ block }) {
  const { lang } = useLang();
  const em = useEditMode();
  const editLang = em.editLang || "en";

  if (!em.editing) {
    const html = block.i18n?.[lang]?.html || block.i18n?.en?.html || "";
    if (!html) return null;
    return (
      <section data-testid={`text-block-${block.id}`} className="relative z-10 bg-[#F9F8F6] py-12 sm:py-16">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <div className="prose prose-lg max-w-none text-[#334155]" dangerouslySetInnerHTML={{ __html: html }} />
        </div>
      </section>
    );
  }

  const rtl = editLang === "he";
  const val = block.i18n?.[editLang]?.html || "";
  return (
    <section data-testid={`text-block-edit-${block.id}`} className="relative z-10 bg-[#F9F8F6] py-10">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <div className="rounded-2xl border-2 border-dashed border-[#BE923C]/50 bg-white p-4">
          <div className="mb-2 flex items-center justify-between">
            <span className="text-xs font-semibold uppercase tracking-wider text-[#BE923C]">Custom text section · {editLang.toUpperCase()}</span>
            <button data-testid={`text-block-remove-${block.id}`} onClick={() => em.removeBlock(block.id)}
              className="flex items-center gap-1 rounded-full px-3 py-1 text-xs font-medium text-red-600 hover:bg-red-50">
              <Trash2 size={13} /> Remove
            </button>
          </div>
          <div dir={rtl ? "rtl" : "ltr"}>
            <RichTextEditor testid={`text-block-editor-${block.id}`} value={val}
              placeholder="Write your text here…"
              onChange={(html) => em.updateBlock(block.id, editLang, { html })} />
          </div>
        </div>
      </div>
    </section>
  );
}
